export const dataprice = [
    {
        title: {
            en: 'Pro',
            es: 'Pro'
        },
        img: 2,
        description: {
            en: "All Applications, full support, and all features included.",
            es: 'Todas las aplicaciones, soporte completo y todas las funciones incluidas.'
        },
        price: '000',
        button: 'primary',
        id: "slide-1"
    },
    {
        title: {
            en: 'Surveys',
            es: 'Encuestas'
        },
        img: 1,
        description: {
            en: "All the Survey-related apps, full support included.",
            es: 'Todas las aplicaciones relacionadas con encuestas, soporte completo incluido.'
        },
        price: '000',
        button: 'secundary',
        id: "slide-2"
    },
    {
        title: {
            en: 'Basic',
            es: 'Básico'
        },
        img: 0,
        description: {
            en: "Only AppSinTi the AppSinTi app, full support included.",
            es: 'Solo la aplicación AppSinTi, soporte completo incluido.'
        },
        price: '000',
        button: 'secundary',
        id: "slide-3"
    },
];